import React from 'react';
import PropTypes from 'prop-types';
import ALERT_BALANCED from '@learningblocks/exp-constants/lib/Images/alert_balanced.svg';
import ALERT_UNBALANCED from '@learningblocks/exp-constants/lib/Images/alert_unbalanced.svg';
import {Image} from '@learningblocks/storybook-components';
import {MCStateContext} from '../../..';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = {
  BALANCED: 'Balanced.string',
  NOT_BALANCED: 'NotBalanced.string',
};

export function BalancedPrompt(props) {
  const {balanced} = React.useContext(MCStateContext);

  const {t} = useTranslation();

  const renderIcon = () =>
    balanced ? (
      <Image src={ALERT_BALANCED} alt='microcentrifuge balanced' />
    ) : (
      <Image src={ALERT_UNBALANCED} alt='microcentrifuge unbalanced' />
    );

  const renderText = () =>
    balanced ? t(TRANSLATION_KEY.BALANCED) : t(TRANSLATION_KEY.NOT_BALANCED);

  return (
    <div className={props.className}>
      {renderIcon()}
      <h4 className='mc_balancedPrompt_text'>{renderText()}</h4>
    </div>
  );
}

BalancedPrompt.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};
